import { createContext, useCallback, useContext, useEffect, useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import pmsApi from 'services/api/pms'

export const GXPLoginContext = createContext({
  isLoading: true,
  hasMissingData: false,
  setActiveStep: _step => {},
  data: {},
  pushToData: _data => {}
})

export function GXPLoginProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true)
  const [hasMissingData, setHasMissingData] = useState(false)
  const [data, setData] = useState({})
  const { addToast } = useToasts()

  useEffect(() => {
    setIsLoading(true)
    pmsApi
      .getMarriotGxpConfig()
      .then(res => {
        setData(v => ({ ...v, ...res }))
      })
      .catch(error => {
        setHasMissingData(true)
        addToast(`${error}`, { appearance: 'error' })
      })
      .finally(() => setIsLoading(false))
  }, [addToast])

  const setActiveStep = useCallback(step => {
    setData(v => ({ ...v, activeStep: step }))
  }, [])

  const pushToData = useCallback(
    newData => setData(oldData => ({ ...oldData, ...newData })),
    []
  )

  return (
    <GXPLoginContext.Provider
      value={{ isLoading, data, setActiveStep, pushToData, hasMissingData }}
    >
      {children}
    </GXPLoginContext.Provider>
  )
}

export const useGXPLogin = () => useContext(GXPLoginContext)
